/******************* VehicleInformation Component *******************************/
import {
    React,
    useRef,
    useReactToPrint,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Paper,
} from "../../common/Imports";

const VehicleInfo = ({ data }) => {
    // Create a ref for the table container
    const tableRef = useRef();

    // Function to handle printing
    const handlePrint = useReactToPrint({
        content: () => tableRef.current,
        pageStyle: `
      @page {
        size: A4;
        margin: 2cm;
      }
    `,
    });

    return (
        <div className="container">
            <div className="table_container">
                <h1>Vehicle Details</h1>
                {/* Button for printing */}
                <Button
                    variant="contained"
                    onClick={handlePrint}
                    style={{
                        backgroundColor: "#1ad5b3",
                        color: "#fff",
                        fontWeight: "600",
                        borderRadius: "20px",
                    }}
                >
                    Print
                </Button>
                {/* Table for displaying vehicle details */}
                <div className="table" ref={tableRef}>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableBody>
                                {/* Rendering rows with hardcoded keys */}
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        Number
                                    </TableCell>
                                    <TableCell>{data.number}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        City
                                    </TableCell>
                                    <TableCell>{data.city}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        State
                                    </TableCell>
                                    <TableCell>{data.state}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        Contact Number
                                    </TableCell>
                                    <TableCell>{data.contactNo}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        Email
                                    </TableCell>
                                    <TableCell>{data.email}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        Address
                                    </TableCell>
                                    <TableCell>{data.address}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        </div>
    );
};

export default VehicleInfo;
